<div class="contest-list__wrapper">
  <h1 class="contest-list__title">{{ "contest.list_title" | translate }}</h1>
  @for (contest of contests; track contest) {
    <app-contest-card
      [contest]="contest">
    </app-contest-card>
  }
</div>